<template>
    <div
        class="col-span-full row-span-full flex items-center justify-center"
        v-bind="$attrs"
    >
        <DsSpinner
            centerIcon="fak fa-cl-logo"
            centerIconSize="xl"
            size="xxxl"
            variant="brand"
        />
    </div>
</template>

<script setup lang="ts">
import DsSpinner from '@/components/design-system/spinner/DsSpinner.vue';
</script>
